<template>
    <add-edit-topevent></add-edit-topevent>
</template>

<script>
import AddEditTopevent from "@/layouts/components/risk-management/top-events/addedit-topevent.vue";

export default {
 components : {
   AddEditTopevent
 },
};
</script>